/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_StrasseInputs */

const de__field_strasse = /** @type {(inputs: _Field_StrasseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Straße und Hausnummer`)
};

/**

* @param {_Field_StrasseInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_strasse = /** @type {((inputs?: _Field_StrasseInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_StrasseInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_strasse(inputs)
});